import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function Newsletter() {
  return <Section background="sand" data-id="element-140">
      <div className="max-w-3xl mx-auto text-center" data-id="element-141">
        <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-142">
          Stay Updated on Our Impact
        </h2>
        <p className="text-lg font-inter text-neutral-charcoal mb-8" data-id="element-143">
          Join our newsletter to receive updates on our work, impact stories,
          and ways to get involved.
        </p>
        <form className="flex flex-col sm:flex-row gap-4" data-id="element-144">
          <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" required data-id="element-145" />
          <Button type="submit" data-id="element-146">Subscribe</Button>
        </form>
        <p className="mt-4 text-sm font-inter text-neutral-charcoal/70" data-id="element-147">
          We respect your privacy. Unsubscribe at any time.
        </p>
      </div>
    </Section>;
}